import { render, staticRenderFns } from "./pls.vue?vue&type=template&id=27141814&scoped=true"
import script from "./pls.vue?vue&type=script&lang=js"
export * from "./pls.vue?vue&type=script&lang=js"
import style0 from "./pls.vue?vue&type=style&index=0&id=27141814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27141814",
  null
  
)

export default component.exports